import React, { useState } from 'react';
import StepsShared from '@shared/components/Steps/steps';
import { useHistory } from 'react-router';
import { FLIGHTS_SEARCH } from '@shared/helpers/routes';
import { ConfirmDialogModal } from '@shared/components/Dialogs';

const FlightSteps = ({ isBuy, isPayment }) => {
  const [showModal, setShowModal] = useState(false);

  const history = useHistory();

  const stepsConfig = {
    box1: {
      title: 'Tu Selección',
      subtitle: 'Seleccioná tu vuelo',
      subtitleMobile: 'Vuelo seleccionado',
    },
    box2: {
      title: 'Tus Datos',
      prefix: 'Ingresa tus',
      suffix: 'datos personales',
    },
    box3: {
      title: 'Último paso',
      subtitle: 'Pago y confirmación de reserva',
      subtitleMobile: 'Pagar y confirmar',
    },
  };

  const activeStep = isPayment ? 3 : 2;

  return (
    <>
      <StepsShared
        searchData={{ isBuy, isPayment, emit: !isBuy }}
        setShowModal={setShowModal}
        activeStep={activeStep}
        stepsConfig={stepsConfig}
      />

      <ConfirmDialogModal
        isOpen={showModal}
        onCancel={() => {
          setShowModal(false);
        }}
        onConfirm={() => {
          history.push(FLIGHTS_SEARCH, { refetch: true });
          setShowModal(false);
        }}
        text="¿Estás seguro de salir? Se borrarán los datos cargados."
      />
    </>
  );
};

export default FlightSteps;
